import { z } from 'zod';
import { answerSchema, hashtagSchema, mentionDataSchema, notificationSchema, postDataUnionSchema, postSchema, profileSchema, reactionDataSchema, rsvpSchema, } from './models.js';
import { groupWithMetaSchema } from './internal.js';
export const dbNotificationSchema = notificationSchema.extend({
    post: postSchema.nullable().optional(),
});
const entryWithProfileSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal('create'),
        data: postDataUnionSchema,
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('edit'),
        data: postDataUnionSchema,
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('delete'),
        data: z.any(),
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('answer'),
        data: answerSchema,
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('rsvp'),
        data: rsvpSchema,
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('reaction'),
        data: z.object({ reaction: z.string().min(1) }),
        uri: z.string().url().optional(),
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
    z.object({
        type: z.literal('unreaction'),
        data: z.object({ reaction: z.string().min(1) }),
        uri: z.string().url().optional(),
        profile: profileSchema,
        createdAt: z.string().datetime(),
    }),
]);
const mentionWithProfileSchema = mentionDataSchema.extend({
    profile: profileSchema,
});
const reactionWithProfileSchema = reactionDataSchema.extend({
    profile: profileSchema,
});
export const dbBasePostSchema = postSchema.extend({
    entries: entryWithProfileSchema.array(),
    audience: profileSchema.array(),
    group: groupWithMetaSchema,
    mentions: mentionWithProfileSchema.array(),
    replyCount: z.number(),
    repostCount: z.number(),
    reactions: reactionWithProfileSchema.array(),
    tags: hashtagSchema.array(),
    profile: profileSchema,
    data: postDataUnionSchema,
    groupId: z.string().nullable().optional(),
    seen: z.boolean().optional(),
});
export const dbPostWithReplySchema = dbBasePostSchema.extend({
    replyTo: dbBasePostSchema.nullable().optional(),
    inReplyToId: z.string().nullable().optional(),
});
export const dbPostSchema = dbPostWithReplySchema.extend({
    repost: dbPostWithReplySchema.nullable().optional(),
});
